export const AuthRoutes = {
    Login: 'login',
    SignUp: 'signup/*',
    SignUpIndex: 'signup',
    PasswordRecovery: 'reset-password',
};
